var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-outro",class:[
		..._vm.className,
		{
			'state-skip': _vm.skipAhead,
		},
	],on:{"click":_vm.Handle_OnClick}},[_c('section',{staticClass:"text-container"},[_c('ViewCosmicText',{attrs:{"align":"center","text":_vm.language.copy_outro_00}}),_c('ViewCosmicText',{attrs:{"align":"center","text":_vm.language.copy_outro_01}}),_c('ViewCosmicText',{attrs:{"align":"center","text":_vm.language.copy_outro_02}})],1),_c('section',{staticClass:"action-contianer"},[_c('section',{staticClass:"primary-action-container"},[_c('ViewButtonReceiveFortune')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }